import { Colors } from '@zapier/design-system';
import { createBuilderModule } from '../../builder';
import { Spacer } from './Spacer';

const emptyBackgroundColorItem = { '': '' };

export default createBuilderModule(Spacer, {
  name: 'Spacer',
  image: '',
  inputs: [
    {
      name: 'height',
      type: 'number',
      required: false,
    },
    {
      name: 'width',
      type: 'number',
      required: false,
    },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: Object.entries({ ...emptyBackgroundColorItem, ...Colors })
        .sort(([a]: [string, string], [b]: [string, string]) =>
          a.localeCompare(b),
        )
        .map(([key, value]) => ({
          label: key,
          value,
        })),
    },
  ],
});
